import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Dashboard } from './dashboard/Dashboard';
import { ZodiacSlider } from './horoscope/ZodiacSlider';
import { CreditPackagesCarousel } from './packages/CreditPackagesCarousel';
import { AuthModal } from './auth/AuthModal';
import { Hero } from './home/Hero';
import { Previews } from './home/Previews';
import { StelaPromo } from './home/StelaPromo';
import { SignsGrid } from './home/SignsGrid';
import { HomeBlog } from './home/HomeBlog';
import { LeadMagnet } from './home/LeadMagnet';
import { StelaFaq } from './home/StelaFaq';
import { CupomTicket } from './home/CupomTicket';
import { Promotions } from './home/Promotions';
import { SocialProof } from './home/SocialProof';
import { SiteFooter } from './home/SiteFooter';
import '../styles/home.css';

export const HomeScreen: React.FC = () => {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);


  // Logado: dashboard de créditos + ferramentas (funil é do visitante) — aditivo
  if (user) {
    return (
      <div className="stela-home">
        <div className="max-w-[1060px] mx-auto px-[18px]">
          <div className="py-6">
            <Dashboard />
          </div>
          <div className="max-w-md mx-auto mb-6">
            <ZodiacSlider />
          </div>
          <Previews />
          <SocialProof />
          <SiteFooter />
        </div>
      </div>
    );
  }

  // Visitante: a ordem EXATA da página modelo (cupom+pacotes no meio, prova no fim)
  return (
    <div className="stela-home">
      <main className="max-w-[1060px] mx-auto px-[18px]">
        <Hero />
        <Previews />
        <StelaPromo />
        <SignsGrid />
        <CupomTicket />

        <section id="pacotes" className="pacotes">
          <h2 className="display">Escolha seu caminho</h2>
          <CreditPackagesCarousel />
        </section>

        <HomeBlog />
        <LeadMagnet />
        <StelaFaq />
        <Promotions />

        <SocialProof />

        <SiteFooter />

        <AuthModal
          isOpen={showAuthModal}
          onClose={() => setShowAuthModal(false)}
          initialMode="signup"
        />
      </main>

    </div>
  );
};